import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Box, IconButton, Typography, Stack, Grid } from "@mui/material";

import CustomFileInput from "../CreateAccount/CustomFileInput";
import { PulseLoader } from "react-spinners";
import { reactComponent as CloseIcon } from "../../assets/close.svg";
import Axios from "../../axios";
import DateFormField from "../DateFormField";
// import { NIN_DUMMY_DATA } from "../../assets/data/data";
// import { PVC_DUMMY_DATA } from "../../assets/data/data";
import ProgressBar from "../ProgressBar";
import Loader from "../loading";
import { Fade } from "react-reveal";
import { useParams } from "react-router-dom";
import { GrClose } from "react-icons/gr";


const init_state = {
  isUploaded: false,
  successMsg: "",
  errorMsg: "",
};

const identity = {
  DL: {
    name: "DL",
    payloadName: "driversLicence",
    value: "Driver's License",
    label: "Driver's License ",
    uploadLabel: "Driver's License",
    url: "/verifyDriverlicense",
    payloadKey: "DriverLicense_number",
  },
  IP: {
    name: "IP",
    value: "International Passport",
    label: "International Passport",
    uploadLabel: "International Passport",
    url: "/verifyPassport",
    payloadKey: "passport_number",
  },
  NIN: {
    name: "NIN",
    value: "National Identification Number",
    label: "National Identification Number",
    uploadLabel: "National Identification Number",
    url: "/verifyNIN",
    payloadKey: "NIN_number",
  },
  VC: {
    name: "VC",
    value: "Voters Card",
    label: "Voters Card",
    uploadLabel: "Voters Card",
    url: "/verifyPVC",
    payloadKey: "PVC_number",
  },
};

const validationLength = {
  DL: 12,
  // DL: 8,
  IP: 9,
  // IP: 8,
  NIN: 11,
  // VC: 16,
  VC: 19,
};

const IdentitiValidation = ({
  accountName,
  customerId,
  navigation,
  lastName,
  setGlobalState,
}) => {
  const { id } = useParams();

  const normaldata = JSON.parse(sessionStorage.getItem("res"));

  const autodata = JSON.parse(sessionStorage.getItem("saveData"));

  //  console.log(autodata)
  //  console.log(normaldata)

  // console.log("BVN: ", BVN);

  const [user, setUser] = useState({
    validatedUsers: [],
  });
  const [userDetails, setUserDetails] = useState({
    myValidatedUsers: [],
  });
  const [identificationData, setIdentificationData] = useState({
    bvn: !id ? normaldata.BVN : autodata.bvn,
  });

  const [jo, setJo] = useState(() => JSON.parse(sessionStorage.getItem("res")));
  // console.log("jo: ", Object.keys(jo).length);
  // console.log("jo: ", jo);

  const { previous, go } = navigation;

  const [formData, setFormData] = useState({
    means_of_id: {
      ...init_state,
      id_number: "",
      idIsValid: false,
    },
    isUploading: false,
    selected: "",
    open: false,
  });

  const [numError, setNumError] = useState({
    DL: "",
    IP: "",
    NIN: "",
    VC: "",
  });

  const [textContent, setTextContent] = useState("");

  const handleSelectMeansOfId = (event) => {
    const { value } = event.target;
    setFormData((prevS) => ({
      ...prevS,
      selected: value,
      open: true,
      means_of_id: {
        init_state,
        id_number: "",
        isValid: false,
      },
    }));
  };

  const closeDialog = () => {
    setFormData((prevS) => ({
      ...prevS,
      selected: "",
      means_of_id: {
        ...init_state,
        id_number: "",
        open: false,
      },
      open: false,
    }));
  };

  const licenseOnChange = (event) => {
    const { value, name } = event.target;
    setNumError((prevS) => ({
      ...prevS,
      [name]: "",
    }));
    setFormData((prevS) => ({
      ...prevS,
      means_of_id: {
        ...prevS.means_of_id,
        id_number: value,
      },
    }));
    if (value.length !== validationLength?.[name]) {
      setNumError((prevS) => ({
        ...prevS,
        [name]: `${identity[formData.selected]?.value} should be ${
          validationLength?.[name]
        } characters long`,
      }));
    }
  };

  const payload = (idCardName) => {
    return [
      ["AccountName", accountName],
      ["customerId", customerId],
      ["idCardName", idCardName],
    ];
  };

  const validateUserIdNumber = (url, payloadKey) => {
    setFormData((prevS) => ({
      ...prevS,
      isUploading: true,
    }));
    const payload = {
      [payloadKey]: formData.means_of_id.id_number,
      bvn: !id ? normaldata.BVN : autodata.bvn,
      // bvn: "22181901282",
      // bvn: "22181918376",
    };
    // console.log("My Payload: ", { payload });
    // const payload = {
    //   [payloadKey]: formData.means_of_id.id_number,
    //   bvn: BVN,
    //   ...(url.includes("verifyPassport") && {
    //     lastName: FirstName || "Musas",
    //   }),
    // };
    Axios.post(url, payload)
      .then((res) => {
        setFormData((prevS) => ({
          ...prevS,
          means_of_id: {
            ...prevS.means_of_id,
            idIsValid: true,
          },
        }));
        if (res) {
          // console.log("Results: ", res?.data?.data?.results);
          // console.log("API: ", res);
          setIdentificationData((prevS) => ({
            ...prevS,
            results: res?.data?.data?.results,
          }));
          sessionStorage.setItem(
            "fullname",
            res?.data?.data?.results?.personal_info?.full_name
          );
        }
      })
      .catch((err) => {
        // console.log({ err });
        if (err) {
          setTimeout(() => {
            setTextContent(
              <p className="text-danger">
                {`please re-enter your correct  ${
                  identity[formData.selected]?.value
                } details`}
              </p>
            );
          }, 1500);
        }
      })
      .finally(() => {
        setFormData((prevS) => ({
          ...prevS,
          isUploading: false,
        }));
        setTextContent("");
      });
  };

  const addValidatedAccount = () => {
    setUser((prevS) => ({
      ...prevS,
      validatedUsers: [
        ...prevS.validatedUsers,
        {
          ...jo[0],
          identity: formData.selected,
        },
      ],
    }));

    const clonedJo = [...jo];
    clonedJo.splice(0, 1);
    setJo(clonedJo);
  };

  // const handleDelete = (num) => {
  //   console.log("here")
  //   console.log(num)
  //   const index = user.validatedUsers.findIndex(({ number }) => number === num);
  //   const user__ = user.validatedUsers.filter(
  //     ({ number }) => number === num
  //   )[0];

  //   const cloned = [...user.validatedUsers];
  //   const _ = cloned.splice(index, 1);

  //   setUser((prevS) => ({
  //     ...prevS,
  //     validatedUsers: cloned,
  //   }));

  //   // setJo((prevS) => [...prevS, user__]);
  // };

  const handleDelete = (num) => {

    // Find the index of the user to be deleted
    


    const index = userDetails.myValidatedUsers.findIndex(({ BVN }) => BVN === num);


    
  
    // Check if the user with the specified number exists
    if (index !== -1) {
      // Create a copy of the validatedUsers array
      const cloned = [...userDetails?.myValidatedUsers];
  
      // Remove the user at the found index
      cloned.splice(index, 1);
  
      // Update the state with the new array
      setUserDetails((prevS) => ({
        ...prevS,
        myValidatedUsers: cloned,
      }))
      setFormData({
        selected: "",
      });

      // setUser((prevS) => ({
      //   ...prevS,
      //   validatedUsers: cloned,
      // }));
  
      // console.log("User deleted:", user?.validatedUsers[index]);
    } else {
      console.warn("User not found with number:", num);
    }
  };

  const handleDateChange = (e) => {
    const { value, name } = e.target;
    // console.log({ name, value });
    setDate((prevS) => ({
      ...prevS,
      [name]: value,
    }));
  };

  const handleNext = () => {
    go("docs");
    setGlobalState((prevS) => ({ ...prevS, formData }));
  };

  const [date, setDate] = useState(() => ({
    issueDate: "",
    expiryDate: "",
  }));

 

  

  const showDetailsOfUsers = () => {
    setUserDetails((prevS) => ({
      ...prevS,
      myValidatedUsers: [
        ...prevS.myValidatedUsers,
        {
          BVN: !id ? normaldata?.BVN : autodata?.bvn,
          FirstName: !id ? normaldata?.FirstName : autodata?.first_name,
          identity: formData?.selected,
          licenseNumber: formData?.means_of_id.id_number,
          issueDate: date?.issueDate,
          expiryDate: date?.expiryDate,
        },
      ],
    }));
   

  };

  useEffect(() => {
        if (userDetails?.myValidatedUsers.length > 0) {
          setFormData((prevS) => ({
            ...prevS,
            open: false,
          }));
        }
      }, [userDetails?.myValidatedUsers]);
  const BVN = !id ? normaldata?.BVN : autodata?.bvn;

  const userArrayDetails = userDetails?.myValidatedUsers[userDetails?.myValidatedUsers?.length - 1];
  // const myNin = NIN_DUMMY_DATA;
  // const myPvc = PVC_DUMMY_DATA;


  

  return (
    <>
      <ProgressBar page="identityValidation" />
      <Fade bottom>
        <form id="msform">
          <fieldset>
            <Box
              sx={{
                width: "40%",
                // display : "flex",
                alignContent: "center",
              }}
              className = "col-12 col-md-6 w-100 mx-auto justify-content-center "
            >
              <Typography
                fontWeight={"light"}
                fontSize="clamp(1.2rem, 1.3rem, 1.55rem)"
                color={"black"}
                marginBottom={"5rem"}
              >
                ...ID Card Validation
              </Typography>

              <Box>
                <Typography>
                  Let's validate{" "}
                  {!id ? normaldata?.FirstName : autodata?.first_name}'s ID
                </Typography>

                <select
                  disabled={(userDetails?.myValidatedUsers?.length > 0)}
                  id="exampleFormControlSelect2"
                  className="form-control select4"
                  name="identity"
                  style={{
                    maxWidth: "20rem",
                    width: "100%",
                    height: 30,
                    minHeight: 45,
                    borderRadius: "20px",
                    marginBottom: "25px",
                  }}
                  value={formData?.selected}
                  onChange={handleSelectMeansOfId}
                >
                  <option disabled={false} value="">
                    Select A Means Of Identification
                  </option>
                  {Object.values(identity).map((identify, idx) => (
                    <option key={identify.name} value={identify.name} id={idx}>
                      {identify.value}
                    </option>
                  ))}
                </select>
              </Box>
              {/* {
          console.log("checkingData: ", user)
        } */}

              {userDetails?.myValidatedUsers?.length > 0 && (
                <Typography variant="body1" sx={{ color: "green" }}>
                  Identity upload was successful{" "}
                  <span
                    role="img"
                    aria-label="emoji"
                    aria-labelledby="myImage"
                  ></span>
                </Typography>
              )}

              <Stack
                direction="row"
                spacing={0}
                sx={{ gap: { xs: 3, md: 4 }, flexWrap: "wrap" }}
              >
                { userDetails?.myValidatedUsers?.length > 0 ? (
                  <Box
                    key={identificationData?.phone_number}
                    sx={{
                      maxWidth: "20rem",
                      width: "100%",
                      p: "1rem",
                      borderRadius: "8px",
                      border: "1px solid #0000001F",
                      backgroundColor: "#e6e7e8",
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography
                        sx={{ fontSize: 12, fontWeight: "bold" }}
                        color="black"
                      >
                        {`${identity[userArrayDetails?.identity]?.value} [${
                          identificationData?.results?.nin_number
                            ? identificationData?.results?.nin_number
                            : identificationData?.results?.pvc_number
                            ? identificationData?.results?.pvc_number
                            : identificationData?.results?.passport_number
                            ? identificationData?.results?.passport_number
                            : ""
                        }]`}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(BVN)}
                      >
                         <GrClose size="22px" />
                      </IconButton>
                    </Stack>

                    <Typography
                      sx={{ fontSize: 18, fontWeight: 500 }}
                      component="p"
                    >
                      {identificationData?.results?.personal_info?.full_name}
                    </Typography>

                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Box>
                          <Typography variant="caption">Issue Date</Typography>

                          <Typography
                            variant="body2"
                            sx={{ fontSize: 18, fontWeight: 500 }}
                          >
                            {identificationData?.results?.passport_number
                              ? identificationData?.results?.date_of_issuance
                              : "Nill"}
                          </Typography>
                        </Box>

                        <Box>
                          <Typography variant="caption">Expiry Date</Typography>

                          <Typography
                            variant="body2"
                            sx={{ fontSize: 18, fontWeight: 500 }}
                          >
                            {identificationData?.results?.passport_number
                              ? identificationData?.results
                                  ?.passport_expiration_date
                              : "Nill"}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <Box>
                          <Typography variant="caption">BVN</Typography>

                          <Typography
                            variant="body2"
                            sx={{ fontSize: 18, fontWeight: 500 }}
                          >
                            {identificationData?.bvn}
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                  </Box>
                ) : ""}

                {/* {formData.means_of_id.isUploaded && (
            <Box
              key={userArrayDetails?.BVN}
              sx={{
                maxWidth: "20rem",
                width: "100%",
                p: "1rem",
                borderRadius: "8px",
                border: "1px solid #0000001F",
                backgroundColor: "#e6e7e8",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography sx={{ fontSize: 12 }} color="black">
                  {`${identity[userArrayDetails?.identity]?.value} [${
                    userArrayDetails?.licenseNumber
                  }]`}
                </Typography>
                <IconButton size="small" onClick={() => handleDelete(BVN)}>
                    
                </IconButton>
              </Stack>

              <Typography sx={{ fontSize: 18, fontWeight: 500 }} component="p">
                {userArrayDetails?.FirstName}
              </Typography>

              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box>
                  <Box>
                    <Typography variant="caption">Issue Date</Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontSize: 18, fontWeight: 500 }}
                    >
                      {userArrayDetails?.issueDate
                        ? userArrayDetails?.issueDate
                        : "Nill"}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography variant="caption">Expiry Date</Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontSize: 18, fontWeight: 500 }}
                    >
                      {userArrayDetails?.expiryDate
                        ? userArrayDetails?.expiryDate
                        : "Nill"}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box>
                    <Typography variant="caption">BVN</Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontSize: 18, fontWeight: 500 }}
                    >
                      {BVN}
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Box>
          )} */}
              </Stack>

              <Box
                display="flex"
                justifyContent="space=between"
                gap={3}
                className=""
              >
                <Button
                  variant="contained"
                  sx={{
                    p: "1rem 3%",
                    m: "2rem 0",
                    backgroundColor: "#354052",
                    width: "10rem",
                  }}
                  onClick={() => go("basicInfo")}
                >
                  Previous
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    p: "1rem 3%",
                    m: "2rem 0",
                    backgroundColor: "#354052",
                    width: "8.5rem",
                  }}
                  // className={`${!formData?.means_of_id?.isUploaded ? "opacity-25" : ""}`}
                  disabled={!(userDetails?.myValidatedUsers?.length > 0)}
                  onClick={handleNext}
                >
                  Next
                </Button>
              </Box>
            </Box>
          </fieldset>
        </form>
      </Fade>
      <Dialog
        key={identity[formData?.selected]?.name}
        open={formData?.open}
        onClose={closeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{identity[formData?.selected]?.value}</DialogTitle>
        <DialogContent
          sx={{
            "& .MuiTextField-root": {
              m: 1,
              width: {
                xs: "100%",
                sm: "6000",
                md: "500px",
                // lg: "1000",
              },
            },
          }}
        >
          <div className="mx-2">
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": {
                  m: 1,
                  width: {
                    xs: "290",
                    sm: "600",
                    md: "600",
                    lg: "900",
                  },
                },
              }}
              noValidate
              autoComplete="off"
            >
              <div className="form-group mx-2">
                <label
                  htmlFor="exampleFormControlTextarea1"
                  className={
                    formData?.means_of_id?.idIsValid
                      ? "text-success"
                      : "text-danger"
                  }
                >
                  {identity[formData?.selected]?.label}
                  <sup className="text-danger">*</sup>
                </label>

                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  gap="10px"
                >
                  {(identity[formData?.selected]?.name === "DL" ||
                    identity[formData?.selected]?.name === "IP") && (
                      <Grid
                      container
                      rowSpacing={1}
                      columns={{ xs: 4, sm: 8, md: 12 }}
                    >
                      <Grid item xs={6}>
                        <DateFormField
                          label="Issue Date"
                          placeholder="Issue Date"
                          name="issueDate"
                          value={date.issueDate}
                          pattern="\d{2}-\d{2}-\d{4}"
                          type="date"
                          onChange={handleDateChange}
                          width="10px"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <DateFormField
                          label="Expiry Date"
                          placeholder="Expiry Date"
                          name="expiryDate"
                          value={date.expiryDate}
                          pattern="\d{2}-\d{2}-\d{4}"
                          type="date"
                          min={date?.issueDate}
                          onChange={handleDateChange}
                        />
                      </Grid>
                    </Grid>
                  )}

                  <TextField
                    sx={{
                      m: "10px",
                      marginBottom: "5px",
                      width: "900px",
                    }}
                    id="outlined-controlled"
                    className="form-control"
                    label={identity[formData?.selected]?.value}
                    name={identity[formData?.selected]?.name}
                    value={formData?.means_of_id?.id_number}
                    onChange={licenseOnChange}
                  />
                  {numError[identity[formData.selected]?.name] && (
                    <p style={{ color: "red" }}>
                      {numError[identity[formData?.selected]?.name]}
                    </p>
                  )}
                  {textContent}
                </Box>

                {/* {console.log("formDataFromInsideReturn", formData)} */}

                {/* {formData.means_of_id.idIsValid && ( */}
                <div style={{ marginTop: "1.5rem" }}>
                  <CustomFileInput
                    state={formData?.means_of_id}
                    setState={setFormData}
                    id="passportPhotograph"
                    objKey="means_of_id"
                    imageType="AllFileTypes"
                    // payload={payload("driversLicence")}
                    label={identity[formData?.selected]?.uploadLabel}
                    // isUploading={formData.isUploading}
                    fullWidth={true}
                    callback={showDetailsOfUsers}
                    // callback={addValidatedAccount}
                  />
                </div>
                {/* )} */}
              </div>
            </Box>
          </div>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button
            onClick={() =>
              validateUserIdNumber(
                identity[formData?.selected]?.url,
                identity[formData?.selected]?.payloadKey
              )
            }
            disabled={
              !formData?.means_of_id?.id_number ||
              formData?.means_of_id?.idIsValid ||
              numError[identity[formData?.selected]?.name] ||
              formData?.means_of_id?.id_number.length !==
                validationLength?.[identity[formData?.selected]?.name]
            }
          >
            {/* {formData.isUploading ? (
              <PulseLoader size="10px" color="#354052" />
            ) : (
              "Validate"
            )} */}
          </Button>
        </DialogActions>
      </Dialog>
      {formData?.isUploading ? (
        <Loader text="Waiting for upload" bgColor="rgba(0,0,0,0.12)" />
      ) : null}
    </>
  );
};

export default IdentitiValidation;


